import React from 'react';
import Header from './Header';
import Hero from './Hero';
import MainContent from './MainContent';
import ArticleContent from './ArticleContent';
import ArticleSidebar from './ArticleSidebar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { DiagnosticForm } from '../components';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <Hero />
      
      {/* Diagnostic Form - Main Content */}
      {/* <div id="diagnostic-form">
        
      </div> */}
      
      {/* Main Content Area */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            {/* <MainContent /> */}
            <DiagnosticForm />
          </div>
          
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <Sidebar />
          </div>
        </div>
      </div>

      {/* Article Section */}
      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* Article Content */}
            <div className="lg:col-span-3">
              <ArticleContent />
            </div>
            
            {/* Article Sidebar */}
            <div className="lg:col-span-1">
              <ArticleSidebar />
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage;
